import { REPORT, REPORT_RANGE } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { countUnique, countUniqueTime } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { styleTime } from '@utils/styles';

export const ResellersCutLastMonthNotThisMonth = () => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_RESELLERS_CUT_LAST_MONTH,
        params: {},
    });

    return (
        <BaseReport
            title={'Resellers that Cut Last Month, but Not This Month'}
            description={
                "This table shows you every Reseller which cut last month, but hasn't cut this month yet (in any of their locations), along with the date and time of the most recent cut. This could indicate the Reseller has closed."
            }
            rangeText={'All Time'}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Reseller Name', 'Last Successful Cuts'],
                data: data.map((item) => [item.resellerName, item.lastSuccessfulCut]),
                summaries: [countUnique, countUniqueTime],
                style: [null, styleTime],
                sort: [basicSort, dateSort(REPORT_RANGE.MONTHLY)],
            }}
        />
    );
};
